import { CUSTOMER_TYPES, ISilentLoginResponse } from '@vfit/consumer/data-access';
import { QueryClient } from 'react-query';
import { checkWindow, getFromLocalStorageByKey } from '@vfit/shared/data-access';
import { IInputs } from '@vfit/shared/models';

const isLoggedR2 = (queryClient: QueryClient) => {
  const coexistenceData: {
    userType: string;
    trustCookie: string;
  } = getFromLocalStorageByKey('coexistenceUser');
  const silentLoginR2: ISilentLoginResponse | undefined = queryClient.getQueryData('silentLoginR2');
  return (
    silentLoginR2?.flowId &&
    silentLoginR2?.flowId === 'existingLogin' &&
    coexistenceData?.userType === CUSTOMER_TYPES.LEGACY
  );
};

const addressInputIsValid = (addressObject: IInputs) => {
  return (
    addressObject?.city &&
    addressObject?.postalCode &&
    addressObject?.stateOrProvince &&
    addressObject?.street &&
    addressObject?.streetNumber
  );
};

const isTechFWA = () => {
  return (
    checkWindow() &&
    localStorage.getItem('isTechFWA') !== 'undefined' &&
    JSON.parse(localStorage.getItem('isTechFWA') as string) === true
  );
};

export { isLoggedR2, addressInputIsValid, isTechFWA };
